import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Col, Row } from 'react-bootstrap'
import NavHeader from './navheader'
import Footer from './footer'
import SubMenu from './submenu'
import MetaTags from 'react-meta-tags'
import ReactHtmlParser from 'react-html-parser';
import BlogComponentLandscape from './blogComponentLandscape'
import ShareButton from 'react-social-share-buttons'
import { getBlogs, getBlogByID } from '../actions'
import { getDateString } from '../utils';
import Slider from 'react-slick'
import ProductItem from './product_item'
import _ from 'lodash'

function PrevArrow(props) {
    const { className, style, onClick } = props
    return (
        <image className={className} onClick={onClick} style={{ width: 35, height: 35, left: '-35px !important' }} src='../../static/images/carouselArrow/backward.png' />
    )
}
function NextArrow(props) {
    const { className, style, onClick } = props
    return (
        <image className={className} onClick={onClick} style={{ width: 35, height: 35, right: '-35px !important' }} src='../../static/images/carouselArrow/forward.png' />
    )
}

class BlogPage extends Component {

    state = {
        loading: true
    }

    componentWillMount() {
        this.props.match.params.blogID == 'all' ? this.props.getBlogs() : this.props.getBlogByID(this.props.match.params.blogID)
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.blog || nextProps.blogs) {
            this.setState({ loading: false })
        }
        if (_.isEmpty(nextProps.blogs) && !_.isEmpty(this.props.blog) && nextProps.match.params.blogID == 'all') {
            this.setState({ loading: true })
            this.props.getBlogs()
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    renderAllBlogs() {
        let id = 0
        return _.map(this.props.blogs, blog => {
            return (
                <Col key={id++} style={{ padding: 0, marginBottom: 10 }} xs={12} sm={6} md={6}>
                    <BlogComponentLandscape blog={blog} />
                </Col>
            )
        })
    }

    renderBlogContent(blog) {
        return (
            <div>{ReactHtmlParser(blog.content)}</div>
        )
    }

    renderSocial(blog) {
        return (
            <div style={{ margin: 10 }}>
                <div style={{ margin: 5, display: 'inline-block' }}>
                    <ShareButton
                        socialMedia={'facebook'}
                        url={window.location.href}
                        media={blog.previewImage}
                        text="songsod.com"
                    />
                </div>
            </div>
        )
    }

    renderCarouselEvent(products, slidesToShow) {
        var setting = {
            responsive: [
                {
                    breakpoint: 767, settings: {
                        dots: false,
                        infinite: true,
                        speed: 500,
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        autoplay: true,
                        swipeToSlide: true,
                        prevArrow: <PrevArrow />,
                        nextArrow: <NextArrow />,
                    }
                },
                {
                    breakpoint: 991, settings: {
                        dots: false,
                        infinite: true,
                        speed: 500,
                        slidesToShow: slidesToShow,
                        slidesToScroll: 1,
                        autoplay: true,
                        swipeToSlide: true,
                        prevArrow: <PrevArrow />,
                        nextArrow: <NextArrow />,
                    }
                },
                {
                    breakpoint: 2599, settings: {
                        dots: false,
                        infinite: true,
                        speed: 500,
                        slidesToShow: slidesToShow,
                        slidesToScroll: 1,
                        autoplay: true,
                        swipeToSlide: true,
                        prevArrow: <PrevArrow />,
                        nextArrow: <NextArrow />,
                    }
                }
            ]
        }
        let id = 0
        let listSiteShow = []
        _.map(products, product => {
            if (product.visible) {
                listSiteShow.push(<div key={id++} style={{ padding: 7 }}><ProductItem isCarousel={true} product={product} history={this.props.history} /></div>)
            }
        })
        if (!_.isEmpty(products)) {
            return (
                <div style={{ paddingLeft: 50, paddingRight: 50 }}>
                    <Slider {...setting}>
                        {listSiteShow}
                    </Slider>
                </div>
            )
        } else {
            return <div></div>
        }
    }

    render() {
        // console.log('metatag')
        const blog = this.props.blog
        return (
            <div>
                <NavHeader history={this.props.history} />
                <SubMenu ref={d => this.submenu = d} history={this.props.history} />
                <div className="container main-bg">
                    {
                        this.props.match.params.blogID == 'all'
                            ? this.state.loading ? <div className='loader'></div>
                                : <div>
                                    <MetaTags>
                                        <title>{'ส่งสด - บริการส่งของสดจากตลาด'}</title>
                                        <meta property="og:title" content={'ส่งสด บริการส่งของสด'} />
                                        <meta property="og:url" content={window.location.href} />
                                        <meta property="og:image" content={'imgsrc'} />
                                        <meta property="og:description" content={'บริการส่งของสดจาก ตลาดยิ่งเจริญ ที่คัดสรรคุณภาพของวัตถุดิบโดยผู้ซื้อสินค้าส่วนตัว'} />
                                        <meta property="og:type" content='website' />
                                        <meta property="fb:pages" content="129193147647837" />
                                    </MetaTags>
                                    <h4 className="header-homepage-product">บทความทั้งหมด</h4>
                                    {this.renderAllBlogs()}
                                </div>
                            :
                            <div>
                                <image style={{ width: '100%' }} src={blog.previewImage} />
                                {this.state.loading ? <div className='loader'></div>
                                    : <div className='blog-container'>
                                        <MetaTags>
                                            <title>{blog.articleName}</title>
                                            <meta property="og:title" content={blog.articleName} />
                                            <meta property="og:url" content={window.location.href} />
                                            <meta property="og:image" content={blog.previewImage} />
                                            <meta property="og:description" content={blog.description} />
                                            <meta property="og:type" content='website' />
                                            <meta property="fb:pages" content="129193147647837" />
                                        </MetaTags>
                                        <h3>{blog.articleName}</h3>
                                        <p>writer: {blog.writer} - {getDateString(blog.creationDate)}</p>
                                        {this.renderSocial(blog)}
                                        {this.renderBlogContent(blog)}
                                    </div>
                                }
                                {!_.isEmpty(blog.products) ?
                                    <div>
                                        <h3 className='header-homepage-product' style={{ paddingLeft: 20 }}>สินค้าอื่นๆที่คุณอาจสนใจ</h3>
                                        {this.renderCarouselEvent((blog.products), 4)}
                                    </div> : ''
                                }
                            </div>
                    }
                </div>
                <Footer history={this.props.history} />
            </div >
        )
    }
}

function mapStateToProps(state) {
    return {
        blogs: state.blogsReducer,
        blog: state.blogReducer,
    }
}

export default connect(mapStateToProps, { getBlogs, getBlogByID })(BlogPage)


// WEBPACK FOOTER //
// ./src/components/blogPage.js